@if (configuration.hasDisabledProducts) {
  <div
    class="small mb-3 ml-3"
    [ngClass]="{
      'text-danger': !configuration.hasQuotation,
      'text-disable-message': configuration.hasQuotation,
    }">
    @if (configuration.hasQuotation) {
      <ng-container>{{ '2d-configurator.quotation.valid-quotation-message' | translate }}</ng-container>
    } @else {
      <ng-container>{{ '2d-configurator.quotation.disable-message' | translate }}</ng-container>
    }
  </div>
}
